import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import * as yup from 'yup';


interface IVitecUserContext {
    isNew: boolean
    isLoading: boolean
    isSaving: boolean
    vitecUser: VitecUser

    saveVitecUser: (distributor: VitecUser) => Promise<void>
}

export let vitecUserSchema = yup.object({
    id: yup.string().default(''),
    firstName: yup.string().default('').required().label("Firstname"),
    lastName: yup.string().default('').required().label("Lastname"),
    email: yup.string().default('').required().label("Email"),
    companyName: yup.string().default(''),
    isSuperAdmin: yup.boolean().default(false),
    canAddDealers: yup.boolean().default(false),
    countries: yup.array(yup.string()).default([])
        .when("canAddDealers", {
            is: true,
            then: yup.array().default([]).min(1, "At least one country must be specified"),
            otherwise: yup.array().default([]),
        })
})

export type VitecUser = yup.InferType<typeof vitecUserSchema>;

export let vitecUserContext = React.createContext({} as IVitecUserContext);

let { Provider } = vitecUserContext;

let VitecUserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let { enqueueSnackbar } = useSnackbar();
    let location = useLocation();
    let history = useHistory();

    let isNew = location.pathname.includes('/addnew');

    let [isLoading, setLoading] = useState(isNew === false);
    let [vitecUser, setVitecUser] = useState<VitecUser>(vitecUserSchema.getDefault());
    let [isSaving, setSaving] = useState(false);


    useEffect(() => {
        if (id)
            getVitecUser(id);
    }, [id])

    let getVitecUser = async (id: string) => {
        try {
            let res = await axios.get('/api/User/GetVitecUser', { params: { id } });
            setVitecUser(res.data.item);
        } catch (err) {
            enqueueSnackbar("Unable to get user", { variant: 'error' });
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    let saveVitecUser = async (vitecUser: VitecUser) => {
        try {
            setSaving(true);
            await axios.post('/api/User/SaveVitecUser', vitecUser);
            history.push('/admin/videndumusers');
        } catch (err) {
            setSaving(false);
        }
    }

    return (
        <Provider
            value={{
                isNew,
                isLoading,
                isSaving,
                vitecUser,

                saveVitecUser
            }}
        >
            {children}
        </Provider>
    )
}

export default VitecUserProvider;